import { Util } from "../common/util";

const util = new Util();

const host =
    process.env.REACT_APP_ENV !== "DEV"
        ? process.env.REACT_APP_API_HOST
        : process.env.REACT_APP_API_DEV_HOST;
const apiPort =
    process.env.REACT_APP_ENV !== "DEV"
        ? process.env.REACT_APP_API_PORT
        : process.env.REACT_APP_API_DEV_PORT;
let apiRoot = process.env.REACT_APP_API_ROOT;

export function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${util.getAccessToken()}`,
  };
}

export function getHostURl() {
  return `${host}:${apiPort}`;
}

export function getURl() {
  return `${host}:${apiPort}/${apiRoot}`;
}
